import { useContext, useRef, useState } from "react";
import { LocaleContext, LoginContext, ScrollContext, StateContext } from "./common/App";
import { ConsumerContext } from ".";
import { Menu, MenuOption } from "./common/Menu";
import { LoadState, MediationStatus } from "./common/enums.mjs";
import "./ConsumerMenu.css";
import { logout, logoutConsumer } from "./common/util";
import { ErrorPopup } from "./common/Common";
import { useNavigateSmart } from "./common/hooks";
import { locationStartPagesSettings } from "./common/globals_common.mjs";
import { useLocation } from "react-router-dom";


export const ConsumerMenu = ({menuVisible, onMenuClick}) => {
    const location = useLocation();

    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);
    const state = useContext(StateContext);
    const consumer = useContext(ConsumerContext);
    const scroll = useContext(ScrollContext);

    const logoutOptionRef = useRef();

    const [loadState, setLoadState] = useState(LoadState.NONE);

    const navigate = useNavigateSmart();


    // FUNCTIONS:

    function handleNewsletterClick() {
        onMenuClick(false);

        if(consumer.newsletter) {
            consumer.setNewsletterSubscribedPopupDisplayed("already subscribed");
        }
        else {
            consumer.setNewsletterPopupDisplayed(true);
        }
    }

    function isStartPage() {
        if(location.pathname === "/") {
            return true;
        }

        for(const s of Object.values(locationStartPagesSettings)) {
            if(location.pathname === s.path) {
                return true;
            }
        }

        return false;
    }


    // RENDER:

    return(
        <Menu menuVisible={menuVisible} onMenuClick={onMenuClick}
                options={
                    <div>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path={isStartPage() ? location.pathname : "/"}
                                exact={true} text={locale.msgs.STARTPAGE}/>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/families/" text={locale.msgs.FOR_FAMILIES}/>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/m_n/" text={locale.msgs.FOR_M_N}/>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/how_it_works/" text={locale.msgs.HOW_BROKERAGE_WORKS}/>

                        <div className="line line_menu"></div>

                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/about_us/" text={locale.msgs.ABOUT_US}/>

                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/blog/" text={locale.msgs.BLOG_POSTS}/>

                        {/*
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/academy/" text={locale.msgs.ACADEMY}/>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/company_events/" text={locale.msgs.COMPANY_EVENTS}/> 
                        <div className="line"></div>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/franchsie/" text={locale.msgs.FRANCHISE}/>
                        */}

                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/diversity/" text={locale.msgs.DIVERSITY}/>
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/contact/" text={locale.msgs.CONTACT}/>
                        <MenuOption setMenuVisible={(visible) => {}} onClick={handleNewsletterClick} text={locale.msgs.NEWSLETTER} />
                        <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/faq/" text={locale.msgs.FAQ_SHORT}/>

                        <div className="line line_menu"></div>

                        { login.loggedIn ?
                                consumer.mediationStatus === MediationStatus.NONE ?
                                    <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/collect_data/how_it_works/" text={locale.msgs.DATA_COLLECTION}/>
                                :
                                    <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/dashboard/" text={locale.msgs.DASHBOARD_CONSUMER}/>
                                
                        :
                            <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/login/" text={locale.msgs.LOGIN}/>
                        }

                        { login.loggedIn ?
                            <div ref={logoutOptionRef}>
                                <MenuOption setMenuVisible={(visible) => {}}
                                        onClick={() => {
                                            try {
                                                logoutConsumer(state, login, consumer).then(() => {
                                                    setLoadState(LoadState.LOAD_SUCCESS);
                                                    onMenuClick(false);
                                                    navigate("/");
                                                    scroll.scrollToPlain(0, 0);
                                                }).catch((error) => {
                                                    console.log(error);
                                                    setLoadState(LoadState.LOAD_ERROR);
                                                });

                                                // Calling setLoadState() after logoutConsumer() as it could throw an exception
                                                setLoadState(LoadState.LOADING);
                                            }
                                            catch(e) {
                                                console.log(e);
                                            }
                                        }}
                                        text={locale.msgs.LOGOUT}
                                        addEle={loadState === LoadState.LOADING ?
                                                <div className="loader menu_option_loader"></div>
                                            :
                                                null
                                        }
                                />
                            </div>
                        :
                            <MenuOption setMenuVisible={(visible) => onMenuClick(visible)} path="/register/" text={locale.msgs.REGISTER}/>
                        }

                        <ErrorPopup helpDisplayed={loadState === LoadState.LOAD_ERROR} btnRef={logoutOptionRef} onClose={() => setLoadState(LoadState.NONE)} />
                    </div>
                }
        ></Menu>
    )
}
